import { FormikToggleField } from 'components/FormikToggleField/FormikToggleField';
import { useLocale } from 'containers/App/LocaleContext';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';

interface CombinedDiscoveryValues {
  combinedDiscovery?: boolean;
}

interface Props<T extends CombinedDiscoveryValues> {
  formik: FormikProps<T>;
}

export const FormikVendorApiCombinedDiscoveryField = <
  T extends CombinedDiscoveryValues,
>(
  props: Props<T>,
): JSX.Element => {
  const {
    discoverySettings: {
      vendorsApi: { labels: labelsMsg },
    },
  } = useLocale();
  return (
    <FormikToggleField
      className='mb-4'
      formik={props.formik}
      name='combinedDiscovery'
      label={labelsMsg.combinedDiscovery}
      labelPosition='right'
      hideStateMessage
    />
  );
};
